import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { BiofluxDirectQuery, BiofluxDirectQueryVariables } from '@/shared/api';
import BIODIRECT_INFO_DRAWER_QUERY from '../queries/biodirectInfoDrawer';

/**
 * Loads the Bioflux Direct record rendered in the info drawer. Runs BIODIRECT_INFO_DRAWER_QUERY and throws the first GraphQL error message when the biofluxDirect field is nil.
 *
 * @param biodirectId - Identifier of the Bioflux Direct record.
 * @returns The Bioflux Direct record.
 */
const fetchBiodirectInfoDrawer = async (biodirectId: any) => {
  const client = createClient();
  const result = await client.query<BiofluxDirectQuery, BiofluxDirectQueryVariables>({
    query: BIODIRECT_INFO_DRAWER_QUERY,
    variables: {
      biodirectId,
    },
  });
  const { data, errors } = result;
  const { biofluxDirect } = data;
  if (_.isNil(biofluxDirect) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return biofluxDirect;
};

export default fetchBiodirectInfoDrawer;
